export const NESHAN_API_KEY = 'service.ed62330ab1cc48478a206dc94d9a4fa7'
